import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { TextValueAccessorDirective, ValidateDirective } from '@skylab-angular-shared/ui';
import { FiscalDevicePaymentMethodsParametersMappingModelWrapper } from '../../fiscal-device-dialog-grid-item';

@Component({
    selector: 'skl-fiscal-device-dialog-grid-mapped-payment-method',
    template: `
    <ins-form-field
        class="no-boundary grid-cell-ins-component">
        <ins-input
            [(ngModel)]="entity.model.mapped"
            [sklValidate]="'mapped.' + entity.model.sun"
            [placeholder]="'scenes.configuration.shared.fiscalization.dialog.grid.columns.mapped-payment-method.placeholder'|translate">
        </ins-input>
    </ins-form-field>`,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [TextValueAccessorDirective, FormsModule, ValidateDirective, TranslatePipe]
})
export class FiscalDeviceDialogGridMappedPaymentMethod {
    @Input() public entity!: FiscalDevicePaymentMethodsParametersMappingModelWrapper;
}
